import { takeEvery, put, call } from "redux-saga/effects"

// Login Redux States
import { GET_PROFILE_GRP_USER } from "./actionTypes"

import { getProfileGRPUser } from "helpers/backend_helper"
import { getProfileForGRPUserFail, getProfileForGRPUserSuccess } from "./actions"

// function* editProfile({ payload: { astroUser } }) {
//   try {
//     console.log("inside editProfile saga ::", astroUser)
//     const response = yield call(editAstroUserProfile, astroUser)
//     yield put(editProfileSuccess(response))

//   } catch (error) {
//     yield put(editProfileError(error))
//   }
// }

// export function* watchProfile() {
//   yield takeEvery(EDIT_PROFILE, editProfile)
// }

function* getProfileSaga() {
  try {
    console.log("inside getProfileSaga :::::::")
    const response = yield call(getProfileGRPUser)
    yield put(getProfileForGRPUserSuccess(response))
  } catch (error) {
    yield put(getProfileForGRPUserFail(error))
  }
}

function* grpProfileSaga() {
  yield takeEvery(GET_PROFILE_GRP_USER, getProfileSaga)
  //yield takeEvery(EDIT_PROFILE, editProfile)
}

export default grpProfileSaga
